import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getDashboardMetricsUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/dashboard-metrics`;
}

export function getAnouncementsUrl(orgId, userId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/announcements`;
}

export function getClientsCountDataUrl(orgId, userId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/count`;
}

@Injectable({
  providedIn: 'root'
})
export class NewTpiqService extends  TaxplanIQServices {

  options = {};
  showAnnouncements: boolean = true;

  constructor(http: HttpClient) {
      super(http);
  }

  getDashboardMetricData(org, userId) {
    const url = getDashboardMetricsUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientsCountData(org, userId) {
    const url = getClientsCountDataUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAnnouncementsList(orgId, userId): any {
    const url = getAnouncementsUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getActiveAnnouncementsForUser(orgId, userId): any {
    let url = getAnouncementsUrl(orgId, userId);
    url += `?active=true`;
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAnouncement(orgId, userId, anouncementId): any {
    let url = getAnouncementsUrl(orgId, userId);
    url += `/${anouncementId}`;
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createOrEditAnouncement(orgId, userId, obj): Observable<any> {
    const url = getAnouncementsUrl(orgId, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removeAnnouncement(orgId, userId, anouncementId){
    let url = getAnouncementsUrl(orgId, userId);
    url += `/${anouncementId}`;
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  announcementAsMarkRead(orgId, userId, announcementId){
    let url = getAnouncementsUrl(orgId, userId);
    url += `/${announcementId}/markread`;
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  setShowAnnouncements(value){
    this.showAnnouncements = value;
  }

  getShowAnnouncements(){
    return this.showAnnouncements || false;
  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }

}

